import { memo, useCallback } from 'react';

interface Step {
  id: string;
  label: string;
  icon: string;
}

interface StepperNavProps {
  steps: readonly Step[];
  currentStep: number;
  onStepClick?: (stepIndex: number) => void;
}

export const StepperNav = memo(function StepperNav({
  steps,
  currentStep,
  onStepClick,
}: StepperNavProps) {
  const handleStepClick = useCallback(
    (index: number) => {
      if (onStepClick) {
        onStepClick(index);
      }
    },
    [onStepClick]
  );

  return (
    <nav className="stepper-nav">
      <ol className="stepper-list">
        {steps.map((step, index) => {
          const isCompleted = index < currentStep;
          const isCurrent = index === currentStep;
          const isActive = index <= currentStep;
          const isLast = index === steps.length - 1;

          return (
            <li
              key={step.id}
              className={`stepper-item ${isLast ? 'stepper-item-last' : ''}`}
            >
              <button
                type="button"
                className={`stepper-step ${isActive ? 'active' : ''} ${isCurrent ? 'current' : ''} ${isCompleted ? 'completed' : ''}`}
                onClick={() => handleStepClick(index)}
              >
                <span className={`stepper-icon ${isActive ? 'active' : ''}`}>
                  {isCompleted ? (
                    <span className="material-symbols-outlined">check</span>
                  ) : (
                    <span className="material-symbols-outlined">{step.icon}</span>
                  )}
                </span>
                <span className="stepper-label">{step.label}</span>
              </button>
              {!isLast && (
                <div className={`stepper-line ${isCompleted ? 'completed' : ''} ${isCurrent ? 'active' : ''}`} />
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
});

export default StepperNav;
